"use client";
import { X } from "lucide-react";
import { EditClassifiedForm } from "./EditClassifieldForm";

export function EditClassifiedModal({
  isOpen,
  onClose,
  classifiedId,
  initialData,
  onSave,
}) {
  if (!isOpen) return null;

  const handleSave = (updatedData) => {
    if (onSave) {
      onSave(updatedData);
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
          onClick={onClose}
        />

        {/* Modal */}
        <div className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900">
              Edit Classified
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          {/* Content */}
          <div className="overflow-y-auto max-h-[calc(90vh-80px)]">
            <EditClassifiedForm
              classifiedId={classifiedId}
              initialData={initialData}
              onSave={handleSave}
              onCancel={onClose}
              onClose={onClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditClassifiedModal;
